<template>
  <div>
    <div class="air__utils__heading">
      <h5>Dashboard</h5>
    </div>
    <!-- {{ $t('welcome') }} -->

    <div class="row">
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  mounted() {
    this.loading = true
    // this.$http.get('/api/reports/dashboard')
    //   .then(({ data }) => {
    //     this.data = data.data
    //     this.loading = false
    //   })
    //   .catch(error => {
    //     console.log(error)
    //     this.loading = false
    //   })
  },
  data() {
    return {
      loading: false,
      data: null,
    }
  },
}
</script>
